import { HTTP_TOKEN_REPORT } from "./http";

export const getMessagesReport = (params) => {
  return HTTP_TOKEN_REPORT.get("report-whats", { params }).then((result) => {
    return result.data;
  });
};
